"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var shared_exports = {};
__export(shared_exports, {
  getParamName: () => getParamName,
  getParamValue: () => getParamValue,
  isDynamicPart: () => isDynamicPart,
  replacePart: () => replacePart
});
module.exports = __toCommonJS(shared_exports);
var getParamName = function getParamName2(pattern) {
  return pattern.replace(/^[:*]/, "").replace(/\?$/, "");
};
function getParamValue(p, value) {
  if (p.startsWith("*")) {
    var values = value.split("/").filter(function(v) {
      return v !== "";
    });
    return values.length === 0 && p.endsWith("?") ? void 0 : values;
  }
  return value;
}
function isDynamicPart(p) {
  return p.length > 1 && (p.startsWith(":") || p.startsWith("*"));
}
function replacePart(p) {
  return p.replace(/^[:*]/, "").replace(/\?$/, "");
}
//# sourceMappingURL=_shared.js.map
